import { useState } from "react";
import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import EditorPicks from "./components/EditorPicks";
import SiteList from "./components/SiteList";
import DownloadPanel from "./components/DownloadPanel";
import SubmitSection from "./components/SubmitSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  const [query, setQuery] = useState("");

  return (
    <div className="min-h-screen w-full bg-background-50 flex flex-col">
      <TopNav />
      <main className="w-full flex-1">
        <Hero query={query} onQueryChange={setQuery} />
        <CategoryGrid />
        <EditorPicks />
        <SiteList query={query} />
        <DownloadPanel />
        <SubmitSection />
        <FaqSection />
      </main>
      <SiteFooter />

      <a
        href="#top"
        aria-label="返回顶部"
        className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </a>
    </div>
  );
}